/* WhatsApp Web inspired styles for Messaging component */
const WA_STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700&display=swap');

/* ── reset ── */
.wa-root *{box-sizing:border-box;-webkit-tap-highlight-color:transparent;margin:0;padding:0;}
.wa-root{
  font-family:'Nunito Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;
  display:flex;width:100%;overflow:hidden;
  height:84vh;min-height:520px;max-height:960px;
  border-radius:12px;
  box-shadow:0 8px 32px rgba(0,0,0,.18);
  border:1px solid #d1d7db;
  background:#f0f2f5;
  position:relative;
}

/* ════════════════════════════════════════
   SIDEBAR
════════════════════════════════════════ */
.wa-sidebar{
  width:30%;min-width:280px;max-width:360px;
  display:flex;flex-direction:column;
  background:#fff;
  border-right:1px solid #e9edef;
  position:relative;z-index:10;
  flex-shrink:0;
  transition:transform .28s cubic-bezier(.4,0,.2,1);
}

/* sidebar top bar */
.wa-sb-topbar{
  display:flex;align-items:center;justify-content:space-between;
  padding:10px 16px;
  background:#f0f2f5;
  border-bottom:1px solid #e9edef;
  min-height:59px;flex-shrink:0;
}
.wa-sb-topbar-actions{display:flex;align-items:center;gap:4px;}
.wa-topbar-btn{
  width:40px;height:40px;border-radius:50%;border:none;
  background:transparent;color:#54656f;
  cursor:pointer;display:flex;align-items:center;justify-content:center;
  font-size:18px;transition:background .15s;flex-shrink:0;
}
.wa-topbar-btn:hover{background:#e9edef;}

/* sidebar search */
.wa-sb-search{padding:8px 12px;background:#f0f2f5;flex-shrink:0;}
.wa-search-box{
  display:flex;align-items:center;gap:10px;
  background:#fff;border-radius:8px;
  padding:8px 14px;
  border:none;
}
.wa-search-box input{
  background:transparent;border:none;outline:none;
  font-size:14px;color:#111b21;width:100%;font-family:inherit;
}
.wa-search-box input::placeholder{color:#8696a0;}
.wa-search-icon{color:#8696a0;font-size:15px;flex-shrink:0;}

/* sidebar nav tabs (Ubutumwa | Bushya | Tangazo | Notifs) */
.wa-sb-tabs{
  display:flex;border-bottom:1px solid #e9edef;
  background:#fff;flex-shrink:0;
}
.wa-tab{
  flex:1;padding:12px 4px;border:none;background:transparent;
  font-size:12px;font-weight:600;color:#8696a0;cursor:pointer;
  border-bottom:3px solid transparent;transition:all .18s;
  display:flex;flex-direction:column;align-items:center;gap:2px;
  position:relative;min-height:48px;
}
.wa-tab.active{color:#00a884;border-bottom-color:#00a884;}
.wa-tab:hover:not(.active){color:#111b21;background:#f5f6f6;}
.wa-tab-icon{font-size:17px;}
.wa-tab-badge{
  position:absolute;top:6px;right:calc(50% - 18px);
  background:#00a884;color:#fff;border-radius:50%;
  width:16px;height:16px;font-size:9px;font-weight:700;
  display:flex;align-items:center;justify-content:center;
}

/* chat list */
.wa-chatlist{flex:1;overflow-y:auto;background:#fff;}
.wa-chatlist::-webkit-scrollbar{width:4px;}
.wa-chatlist::-webkit-scrollbar-thumb{background:#e9edef;border-radius:4px;}

/* chat list item */
.wa-chat-item{
  display:flex;align-items:center;gap:12px;
  padding:10px 16px;cursor:pointer;
  border-bottom:1px solid #e9edef;
  transition:background .12s;position:relative;
  min-height:72px;
}
.wa-chat-item:hover{background:#f5f6f6;}
.wa-chat-item.active{background:#f0f2f5;}
.wa-chat-item.active::before{
  content:'';position:absolute;left:0;top:0;bottom:0;
  width:4px;background:#00a884;border-radius:0 3px 3px 0;
}

.wa-chat-av-wrap{position:relative;flex-shrink:0;}
.wa-av{
  border-radius:50%;display:flex;align-items:center;justify-content:center;
  font-weight:600;color:#fff;flex-shrink:0;font-size:16px;
}
.wa-online-ring{
  position:absolute;bottom:1px;right:1px;
  width:11px;height:11px;border-radius:50%;
  background:#25d366;border:2px solid #fff;
}

.wa-chat-body{flex:1;min-width:0;}
.wa-chat-header-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:3px;}
.wa-chat-name{font-size:15px;font-weight:500;color:#111b21;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.wa-chat-time{font-size:11.5px;color:#8696a0;flex-shrink:0;margin-left:6px;}
.wa-chat-time.unread{color:#00a884;}
.wa-chat-preview-row{display:flex;align-items:center;justify-content:space-between;}
.wa-chat-preview{font-size:13.5px;color:#8696a0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1;}
.wa-unread-badge{
  background:#00a884;color:#fff;border-radius:50%;
  width:20px;height:20px;font-size:11px;font-weight:700;
  display:flex;align-items:center;justify-content:center;
  flex-shrink:0;margin-left:6px;
}
.wa-pinned-icon{color:#8696a0;font-size:12px;margin-left:4px;}
.wa-muted-icon{color:#8696a0;font-size:13px;margin-left:4px;}

/* section header in list */
.wa-list-section{
  padding:7px 16px 5px;
  font-size:12px;font-weight:700;color:#8696a0;
  text-transform:uppercase;letter-spacing:.06em;
  background:#f0f2f5;border-bottom:1px solid #e9edef;
}

/* contact item (new chat) */
.wa-contact-item{
  display:flex;align-items:center;gap:12px;
  padding:10px 16px;cursor:pointer;border-bottom:1px solid #e9edef;
  transition:background .12s;min-height:64px;
}
.wa-contact-item:hover{background:#f5f6f6;}
.wa-contact-item.selected{background:#e9f5f2;}
.wa-role-tag{font-size:10.5px;font-weight:600;padding:1px 7px;border-radius:10px;color:#fff;display:inline-block;margin-top:2px;}

/* notif item */
.wa-notif-item{padding:11px 16px;cursor:pointer;border-bottom:1px solid #e9edef;transition:background .12s;}
.wa-notif-item:hover{background:#f5f6f6;}
.wa-notif-item.unread{background:#e9f5f2;}

/* broadcast item */
.wa-bc-item{padding:11px 16px;cursor:pointer;border-bottom:1px solid #e9edef;border-left:3px solid transparent;transition:background .12s;}
.wa-bc-item:hover{background:#f5f6f6;}
.wa-bc-item.unread{background:#fffbe6;border-left-color:#f59f00;}

/* empty list */
.wa-list-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 20px;gap:10px;color:#8696a0;text-align:center;}
.wa-list-empty-icon{font-size:52px;opacity:.4;}

/* ════════════════════════════════════════
   MAIN CHAT
════════════════════════════════════════ */
.wa-main{
  flex:1;display:flex;flex-direction:column;min-width:0;
  background:#efeae2;
  background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80'%3E%3Cpath d='M0 0h80v80H0z' fill='none'/%3E%3Ccircle cx='40' cy='40' r='1' fill='%23c1b99a' fill-opacity='.35'/%3E%3Ccircle cx='0' cy='0' r='1' fill='%23c1b99a' fill-opacity='.35'/%3E%3Ccircle cx='80' cy='0' r='1' fill='%23c1b99a' fill-opacity='.35'/%3E%3Ccircle cx='0' cy='80' r='1' fill='%23c1b99a' fill-opacity='.35'/%3E%3Ccircle cx='80' cy='80' r='1' fill='%23c1b99a' fill-opacity='.35'/%3E%3C/svg%3E");
  position:relative;
}

/* chat header */
.wa-chat-head{
  display:flex;align-items:center;gap:10px;
  padding:10px 16px;
  background:#f0f2f5;
  border-bottom:1px solid #e9edef;
  flex-shrink:0;min-height:59px;
  position:relative;z-index:5;
}
.wa-chat-head-info{flex:1;min-width:0;cursor:pointer;}
.wa-chat-head-name{font-size:15.5px;font-weight:600;color:#111b21;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.wa-chat-head-sub{font-size:12.5px;color:#8696a0;margin-top:1px;display:flex;align-items:center;gap:5px;}
.wa-online-dot{width:8px;height:8px;border-radius:50%;background:#25d366;flex-shrink:0;}
.wa-head-actions{display:flex;align-items:center;gap:2px;}
.wa-head-btn{
  width:40px;height:40px;border-radius:50%;border:none;
  background:transparent;color:#54656f;font-size:18px;
  cursor:pointer;display:flex;align-items:center;justify-content:center;
  transition:background .15s;flex-shrink:0;
}
.wa-head-btn:hover{background:#e9edef;}
.wa-back-btn{
  background:none;border:none;color:#54656f;font-size:22px;
  cursor:pointer;padding:4px 8px 4px 0;display:flex;align-items:center;
  min-width:36px;border-radius:50%;transition:background .15s;
}
.wa-back-btn:hover{background:#e9edef;}

/* messages scroll */
.wa-messages{
  flex:1;overflow-y:auto;
  padding:12px 8% 8px;
  display:flex;flex-direction:column;
  gap:2px;
}
.wa-messages::-webkit-scrollbar{width:5px;}
.wa-messages::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;}

/* date chip */
.wa-date-chip{
  display:flex;justify-content:center;margin:10px 0;
}
.wa-date-chip span{
  background:rgba(255,255,255,.85);backdrop-filter:blur(4px);
  color:#54656f;font-size:12px;font-weight:500;
  padding:4px 14px;border-radius:8px;
  box-shadow:0 1px 2px rgba(0,0,0,.1);
}

/* message row */
.wa-msg-row{
  display:flex;flex-direction:column;
  animation:waFadeIn .2s ease-out;
  margin-bottom:2px;
}
.wa-msg-row.sent{align-items:flex-end;}
.wa-msg-row.recv{align-items:flex-start;}

.wa-sender-label{
  font-size:12px;font-weight:600;
  margin-bottom:2px;padding:0 4px;
}

/* bubble */
.wa-bubble{
  padding:7px 10px 5px 10px;
  border-radius:8px;
  max-width:65%;
  word-break:break-word;white-space:pre-wrap;
  position:relative;
  box-shadow:0 1px 1px rgba(0,0,0,.1);
}
.wa-bubble.sent{
  background:#d9fdd3;
  border-top-right-radius:0;
}
.wa-bubble.recv{
  background:#fff;
  border-top-left-radius:0;
}
/* bubble tail */
.wa-bubble.sent::before{
  content:'';position:absolute;top:0;right:-8px;
  border:8px solid transparent;
  border-top-color:#d9fdd3;border-right:0;
}
.wa-bubble.recv::before{
  content:'';position:absolute;top:0;left:-8px;
  border:8px solid transparent;
  border-top-color:#fff;border-left:0;
}
.wa-bubble-text{font-size:14.5px;line-height:1.5;color:#111b21;}
.wa-bubble-img{max-width:280px;max-height:220px;border-radius:6px;display:block;cursor:zoom-in;object-fit:cover;margin-bottom:4px;}
.wa-bubble-foot{
  display:flex;align-items:center;justify-content:flex-end;
  gap:4px;margin-top:2px;
}
.wa-bubble-time{font-size:11px;color:#8696a0;}
.wa-ticks{font-size:13px;}
.wa-ticks.read{color:#53bdeb;}
.wa-ticks.delivered{color:#8696a0;}

/* file bubble */
.wa-file-bubble{
  display:flex;align-items:center;gap:10px;
  padding:10px 12px;border-radius:8px;
  background:rgba(0,0,0,.05);margin-bottom:4px;
  text-decoration:none;color:inherit;
}
.wa-file-icon{font-size:28px;flex-shrink:0;}
.wa-file-info{min-width:0;}
.wa-file-name{font-size:13.5px;font-weight:500;color:#111b21;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:180px;}
.wa-file-dl{font-size:11px;color:#00a884;font-weight:600;margin-top:2px;}

/* delete msg btn */
.wa-del-msg{
  opacity:0;background:rgba(0,0,0,.1);border:none;
  border-radius:50%;width:26px;height:26px;cursor:pointer;
  color:#54656f;font-size:12px;display:flex;align-items:center;
  justify-content:center;flex-shrink:0;transition:all .15s;
}
.wa-bubble-wrap:hover .wa-del-msg{opacity:1;}
.wa-del-msg:hover{background:rgba(0,0,0,.2);}
.wa-bubble-wrap{display:flex;align-items:flex-end;gap:4px;}
.wa-msg-row.sent .wa-bubble-wrap{flex-direction:row-reverse;}

/* typing */
.wa-typing{
  display:flex;align-items:center;gap:4px;
  padding:10px 14px;background:#fff;
  border-radius:8px;align-self:flex-start;
  box-shadow:0 1px 1px rgba(0,0,0,.1);
  margin-bottom:4px;border-top-left-radius:0;
}
.wa-typing::before{content:'';position:absolute;top:0;left:-8px;border:8px solid transparent;border-top-color:#fff;border-left:0;}
.wa-typing-wrap{position:relative;}
.wa-tdot{width:7px;height:7px;border-radius:50%;background:#8696a0;animation:waBounce 1.2s infinite;}
.wa-tdot:nth-child(2){animation-delay:.2s;}
.wa-tdot:nth-child(3){animation-delay:.4s;}

/* ── INPUT BAR ── */
.wa-input-bar{
  display:flex;align-items:flex-end;gap:8px;
  padding:10px 16px;
  background:#f0f2f5;
  border-top:1px solid #e9edef;
  flex-shrink:0;
}
.wa-input-icon-btn{
  width:44px;height:44px;border-radius:50%;border:none;
  background:transparent;color:#54656f;font-size:22px;
  cursor:pointer;display:flex;align-items:center;justify-content:center;
  flex-shrink:0;transition:background .15s;
}
.wa-input-icon-btn:hover{background:#e9edef;}
.wa-input-box{
  flex:1;
  background:#fff;border-radius:22px;
  padding:11px 16px;
  font-size:15px;font-family:inherit;
  border:none;outline:none;color:#111b21;
  resize:none;overflow-y:auto;
  min-height:44px;max-height:120px;
  line-height:1.45;
  caret-color:#00a884;
}
.wa-input-box::placeholder{color:#8696a0;}
.wa-send-btn{
  width:48px;height:48px;border-radius:50%;border:none;
  background:#00a884;color:#fff;font-size:20px;
  cursor:pointer;display:flex;align-items:center;justify-content:center;
  flex-shrink:0;transition:all .18s;
  box-shadow:0 2px 8px rgba(0,168,132,.35);
}
.wa-send-btn:hover:not(:disabled){background:#017f64;transform:scale(1.05);}
.wa-send-btn:disabled{background:#8696a0;box-shadow:none;cursor:default;transform:none;}
.wa-attach-strip{
  display:flex;align-items:center;gap:8px;
  background:#fff;border-radius:10px;padding:7px 12px;
  margin:0 16px 8px;font-size:13px;color:#00a884;
  border:1px solid #e9edef;
}
.wa-attach-strip-x{background:none;border:none;color:#e53935;cursor:pointer;font-size:15px;padding:0 2px;line-height:1;}

/* ── WELCOME SCREEN ── */
.wa-welcome{
  flex:1;display:flex;flex-direction:column;
  align-items:center;justify-content:center;
  gap:16px;text-align:center;padding:40px 20px;
  background:#f8f9fa;
  border-top:4px solid #00a884;
}
.wa-welcome-lock{font-size:13px;color:#8696a0;display:flex;align-items:center;gap:6px;margin-top:8px;}

/* ── RIGHT PANEL ── */
.wa-panel{
  width:27%;min-width:240px;max-width:340px;
  background:#fff;border-left:1px solid #e9edef;
  display:flex;flex-direction:column;flex-shrink:0;
  overflow:hidden;
}
.wa-panel-head{
  background:#f0f2f5;padding:16px;
  border-bottom:1px solid #e9edef;
  display:flex;align-items:center;gap:10px;min-height:59px;
}
.wa-panel-title{font-size:16px;font-weight:600;color:#111b21;}
.wa-panel-close{background:none;border:none;color:#54656f;font-size:20px;cursor:pointer;margin-left:auto;padding:4px;border-radius:50%;transition:background .15s;}
.wa-panel-close:hover{background:#e9edef;}
.wa-panel-body{flex:1;overflow-y:auto;padding:0;}
.wa-panel-section{padding:14px 16px;border-bottom:1px solid #f0f2f5;}
.wa-panel-section-title{font-size:12px;font-weight:700;color:#00a884;text-transform:uppercase;letter-spacing:.06em;margin-bottom:10px;}
.wa-panel-avatar{border-radius:50%;margin:0 auto 10px;display:flex;align-items:center;justify-content:center;font-weight:600;color:#fff;}
.wa-media-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:3px;}
.wa-media-thumb{aspect-ratio:1;border-radius:6px;object-fit:cover;width:100%;cursor:zoom-in;transition:opacity .15s;}
.wa-media-thumb:hover{opacity:.8;}
.wa-panel-action{
  display:flex;align-items:center;gap:12px;
  padding:14px 16px;cursor:pointer;border-bottom:1px solid #f0f2f5;
  color:#111b21;font-size:14px;transition:background .12s;
}
.wa-panel-action:hover{background:#f5f6f6;}
.wa-panel-action.danger{color:#ea0038;}
.wa-panel-action-icon{font-size:20px;color:#8696a0;width:24px;text-align:center;}
.wa-panel-action.danger .wa-panel-action-icon{color:#ea0038;}

/* ── FORMS ── */
.wa-form-wrap{flex:1;overflow-y:auto;background:#f8f9fa;display:flex;align-items:center;justify-content:center;padding:32px 20px;}
.wa-form-card{background:#fff;border-radius:12px;padding:28px 24px;width:100%;max-width:440px;box-shadow:0 2px 8px rgba(0,0,0,.08);}
.wa-form-title{font-size:18px;font-weight:700;color:#111b21;margin-bottom:20px;display:flex;align-items:center;gap:8px;}
.wa-form-lbl{display:block;font-size:13px;font-weight:600;color:#54656f;margin-bottom:5px;}
.wa-form-ctrl{width:100%;padding:10px 13px;border:1.5px solid #e9edef;border-radius:8px;font-size:14.5px;outline:none;background:#fff;color:#111b21;font-family:inherit;transition:border-color .18s;margin-bottom:14px;}
.wa-form-ctrl:focus{border-color:#00a884;}
.wa-form-btn{width:100%;padding:13px;border:none;border-radius:8px;background:#00a884;color:#fff;font-size:15px;font-weight:700;cursor:pointer;transition:background .18s;}
.wa-form-btn:hover:not(:disabled){background:#017f64;}
.wa-form-btn:disabled{opacity:.5;cursor:default;}
.wa-bc-send-btn{width:100%;padding:13px;border:none;border-radius:8px;background:#f59f00;color:#fff;font-size:15px;font-weight:700;cursor:pointer;margin-top:4px;}
.wa-bc-send-btn:disabled{opacity:.5;cursor:default;}
.wa-back-link{background:none;border:none;color:#00a884;font-size:14px;cursor:pointer;padding:4px 0;margin-bottom:14px;display:flex;align-items:center;gap:5px;font-weight:600;}
.wa-selected-contact-card{display:flex;align-items:center;gap:12px;background:#e9f5f2;border-radius:10px;padding:12px 14px;margin-bottom:16px;}
.wa-stats-row{display:flex;gap:24px;justify-content:center;margin-top:16px;flex-wrap:wrap;}
.wa-stat-box{text-align:center;}
.wa-stat-num{font-size:28px;font-weight:800;color:#00a884;}
.wa-stat-lbl{font-size:11px;color:#8696a0;font-weight:600;text-transform:uppercase;letter-spacing:.04em;}

/* ── LIGHTBOX ── */
.wa-lb{position:fixed;inset:0;background:rgba(0,0,0,.9);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;cursor:zoom-out;}
.wa-lb img{max-width:90vw;max-height:90vh;border-radius:8px;box-shadow:0 20px 60px rgba(0,0,0,.5);}
.wa-lb-close{position:absolute;top:16px;right:20px;background:rgba(255,255,255,.15);border:none;color:#fff;font-size:20px;width:44px;height:44px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;}

/* ── ANIMATIONS ── */
@keyframes waFadeIn{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:translateY(0);}}
@keyframes waBounce{0%,80%,100%{transform:scale(0);}40%{transform:scale(1);}}

/* ── RESPONSIVE ── */
@media(max-width:1100px){.wa-panel{display:none;}}
@media(max-width:860px){
  .wa-sidebar{width:35%;min-width:240px;}
  .wa-bubble{max-width:75%;}
}
@media(max-width:720px){
  .wa-root{border-radius:0;border:none;height:100dvh;max-height:none;}
  .wa-sidebar{
    position:absolute;top:0;left:0;bottom:0;
    width:100%!important;max-width:100%!important;min-width:100%!important;
    z-index:20;
  }
  .wa-sidebar.wa-hidden{transform:translateX(-100%);pointer-events:none;}
  .wa-main{position:absolute;inset:0;z-index:15;}
  .wa-bubble{max-width:82%;}
  .wa-messages{padding:10px 4% 6px;}
}
@media(max-width:420px){
  .wa-bubble{max-width:88%;}
  .wa-input-box{font-size:16px;}
  .wa-chat-name{font-size:14px;}
}
/* Phones: the name/role need the header width — search/call/video icons (which
   have no action yet) are hidden, and the input bar is tightened. */
@media(max-width:600px){
  .wa-head-extra{display:none;}
  .wa-chat-head{padding:8px 10px;gap:8px;}
  .wa-chat-head-sub{min-width:0;}
  .wa-input-bar{padding:8px;gap:4px;}
  .wa-input-icon-btn{width:40px;height:40px;font-size:20px;}
  .wa-input-box{padding:10px 14px;min-width:0;}
  .wa-send-btn{width:44px;height:44px;}
  .wa-chat-head-name{font-size:15px;}
  .wa-input-box::placeholder{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
}
/* Inside the dashboard the page header and bottom nav take space too, so a
   full 100dvh chat would push the input bar off screen. */
@media(max-width:720px){
  .dashboard-wrapper .wa-root{height:calc(100dvh - 170px);min-height:420px;border-radius:14px;}
}
@media(prefers-reduced-motion:reduce){
  .wa-msg-row,.wa-tdot{animation:none!important;}
}
`;

export default WA_STYLES;
